module.exports = __webpack_public_path__ + "img/bullx.c9877ae3.jpg";